// INSTAACARD mobile app store links.
// Locale/storefront segments are intentionally omitted so each visitor is
// routed to their own regional store.
export const APP_STORE_URL = 'https://apps.apple.com/app/id6755238350';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.instaacard.app';
